import { NgxAddress } from "src/app/models/ngxAddress";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function addressChange(event: any): NgxAddress {
  let city = "";
  let pinCode = "";
  let state = "";
  let area = "";
  let country = "";
  const lat: number = event.geometry.location.lat();
  const lng: number = event.geometry.location.lng();
  const address: string = event["formatted_address"];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  event.address_components.forEach((element: any) => {
    if (element.types.includes("sublocality_level_1")) {
      area = element.long_name;
    }
    if (element.types.includes("administrative_area_level_1")) {
      state = element.long_name;
    }
    if (element.types.includes("administrative_area_level_2")) {
      city = element.long_name;
    }
    if (element.types.includes("postal_code")) {
      pinCode = element.long_name;
    }
    if (element.types.includes("country")) {
      country = element.long_name;
    }
  });

  const data = {
    pinCode,
    state,
    city,
    area,
    country,
    lat,
    lng,
    address,
  };

  return data;
}
